<template>
	<div>
        <md-progress-bar v-if="inProgress" md-mode="indeterminate"/>
        <div>
            <div class="expired" v-if="!uploadKey || !targetConnectionId">
                {{this.sessionInit ? 'Сессия истекла' : 'Загрузка данных сессии'}}
            </div>
            <div v-else class="main-container">
                <div class="controls">
                    <md-button @click="clickFileInput()" class="md-raised" :disabled="inProgress">
                        <md-icon>attach_file</md-icon>
                        Прикрепить фото или файл
                    </md-button>
                    <md-field style="display: none">
                        <md-file id="file-input" @md-change="onFileUpload($event)" multiple />
                    </md-field>
                    <md-button @click="sendFiles()" class="md-raised md-primary" :disabled="inProgress">
                        <md-icon>file_upload</md-icon>
                        Отправить
                    </md-button>
                </div>
                <div v-if="files.length != 0" class="image-container">
                    <div class="attachments-item" v-for="file of files" :key="file.name">
                        <img class="att-image" :src="`${createFileUrl(file)}`" />
                        <md-button class="md-icon-button remove-attachment md-raised md-accent" @click="removeAttachment(file)" :disabled="inProgress">
                            <md-icon>close</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
        </div>
        <md-snackbar :md-active.sync="showSnack">
            {{snackMessage}}
        </md-snackbar>
	</div>
</template>
<script>
    import { mapGetters } from "vuex";
	export default {
		name: "FileUpload",
		data: () => ({
            uploadKey: null,
            connectionId: null,
            targetConnectionId: null,
            targetTickedId: null,
            files: [],
            inProgress: false,
            showSnack: false,
            snackMessage: '',
            sessionInit: false
		}),
		computed: {
			...mapGetters(
				[
					'KNOWNFILETYPES'
				]
			)
		},

		methods: {
			clickFileInput() {
                document.getElementById('file-input').click();
			},
			onFileUpload(fileList) {
                Array.from(fileList).forEach(file => this.files.push(file));
                document.getElementById("file-input").value = null;
			},
            createFileUrl(file) {
                if (!file) {
                    return '#';
                }
                if (file && file['type'].split('/')[0] === 'image') {
                    return URL.createObjectURL(file)
                }
                return this.calcTypeOfAttachmentForAttachedFiles(file);
			},
			calcTypeOfAttachmentForAttachedFiles(file) {
                let fileName = file.name;
                //определяем расширение файла
                let fileType = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
                fileType = fileType.toLowerCase();
                return this.KNOWNFILETYPES.includes(fileType) ? `/dist/svg/${fileType}.svg` : `/dist/svg/raw.svg`;
            },
            removeAttachment(attachment) {
                let index = this.files.indexOf(attachment);
                if (index !== -1) this.files.splice(index, 1);
            },
            sendFiles() {
                this.inProgress = true;
                let formData = new FormData();

                this.files.forEach(file => formData.append('files', file));
                formData.append('uploaderConnectionId', this.$QBHub.connectionId);
                formData.append('uploadKey', this.uploadKey);
                this.$http.post("data/SendFilesToClient", formData).then(
                    (response) => {
                        if (!response.body.ok) {
                            this.snackMessage = response.data.error;
                        }
                        else {
                            this.snackMessage = "Файлы отправлены";
                        }
                        this.showSnack = true;
                        this.inProgress = false;
                        this.files = [];
                    },
                    (error) => {
                        this.inProgress = false;
                    }
                );
            },
            startUploadSession(connectionId) {
                this.sessionInit = false;
                this.connectionId = connectionId;
                this.$http.post("data/StartUploadSession", { uploadKey: this.uploadKey, connectionId: connectionId }).then(
                    (response) => {
                        this.targetConnectionId = response.body.connectionId;
                        this.targetTickedId = response.body.ticketId;
                        this.sessionInit = true;
                    }
                )
            },
            onSignalrConnectionChanged(data) {
                this.startUploadSession(data.connectionId);
            },
            onInvalidate() {
                this.uploadKey = null;
            }
		},
        mounted() {
            this.uploadKey = this.$route.query.uploadKey;
            if (this.$QBHub.connectionId) {
                startUploadSession(this.$QBHub.connectionId);
            }
        },
        created() {
            this.$QBHub.$on('connectionIdChanged', this.onSignalrConnectionChanged);
            this.$QBHub.$on('invalidateUploadSession', this.onInvalidate);
        },
        beforeDestroy() {
            this.$QBHub.$off('connectionIdChanged', this.onSignalrConnectionChanged);
            this.$QBHub.$off('invalidateUploadSession', this.onInvalidate);
        }
	}
</script>
<style>
    body {
        background-color: lightgray;
    }

    .main-container {
        display: flex;
        flex-direction: column-reverse;
        height: 90vh;
    }

    .attachments-item {
        position: relative;
        padding: 10px;
    }

    .remove-attachment {
        position: absolute;
        top: 16px;
        right: 16px;
    }

    .attachments-item .remove-attachment:hover {
        cursor: pointer;
        background-color: #448AFF;
        color: white;
    }

    .attachments-item .att-image {
        min-width: 100%;
    }

    .controls {
        display: flex;
        flex-direction: column;
        background-color: lightgray;
    }

    .image-container {
        overflow-y: auto;
    }

    .expired {
        top: 50%;
        width: 100%;
        text-align: center;
        position: absolute;
        text-transform: uppercase;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// Components/supportNew/fileUpload.vue